import layout from 'layouts/default'
import moment from 'moment'

const components = {
  layout
}

const computed = {
  action () {
    return _.cloneDeep(this.$store.state.reservationActions.active) || {}
  },

  errorMessage () {
    const errors = this.$store.state.reservationActions.errors
    return errors ? (errors.message || 'Unable to load the reservation action') : ''
  }
}

const methods = {
  display (value) {
    return value !== null && value !== undefined && value !== '' ? value : '-'
  },

  formatDate (value) {
    if (!value) return '-'
    const date = moment(value)
    return date.isValid() ? date.format('MM/DD/YYYY hh:mm A') : value
  },

  formatLabel (value) {
    if (!value) return '-'
    return String(value)
      .replace(/_/g, ' ')
      .replace(/\b\w/g, (letter) => letter.toUpperCase())
  },

  loadAction () {
    this.loading = true
    this.$store.dispatch('reservationActions.get', this.$route.params.id)
    .then(() => {
      this.loading = false
    })
  }
}

export default {
  name: 'reservation-action-details',
  components,
  computed,
  methods,
  data () {
    return {
      loading: true
    }
  },
  created () {
    this.loadAction()
  }
}
